import React, { useEffect, useRef, useState } from 'react'
import PropTypes from 'prop-types'
import { DeleteIcon, EllipsisIcon, SmallEditIcon } from 'secondstep-components'
import HideIcon from './HideIcon'
import {
  ClassCardMenuButton,
  DeleteButton,
  DropdownMenuWrapper,
  EditButton,
  HideButton,
  MyClassesMenuButton,
  Wrapper,
} from './component.styles'

const DropdownMenu = ({
  className,
  courseInstanceName,
  dataTestId,
  handleDeleteSubmit,
  handleEditSubmit,
  handleHideSubmit,
  isClassCardMenu,
  forwardedRef,
}) => {
  const [isOpen, setIsOpen] = useState(false)
  const menuRef = useRef(null)

  useEffect(() => {
    const handleClickOutside = event => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setIsOpen(false)
      }
    }

    document.addEventListener('mousedown', handleClickOutside)
    document.addEventListener('keydown', handleClickOutside)

    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
      document.removeEventListener('keydown', handleClickOutside)
    }
  })

  const CardMenuButton = isClassCardMenu
    ? ClassCardMenuButton
    : MyClassesMenuButton

  return (
    <Wrapper className={className} ref={menuRef}>
      <CardMenuButton
        aria-label="Class Card Menu Button"
        className="dropdown-menu-button"
        dataTestId={dataTestId}
        isOpen={isOpen}
        onClick={() => setIsOpen(!isOpen)}
        ref={forwardedRef}
      >
        <EllipsisIcon />
      </CardMenuButton>
      {isOpen && (
        <DropdownMenuWrapper className="dropdown-menu-wrapper">
          <EditButton
            aria-label="Class Card Edit Button"
            className="edit-button"
            dataTestId="edit-button"
            onClick={() => handleEditSubmit()}
          >
            <SmallEditIcon />
            <p>Edit</p>
          </EditButton>
          {handleHideSubmit && (
            <HideButton
              aria-label="Class Card Hide Button"
              className="hide-button"
              dataTestId="hide-button"
              onClick={() => handleHideSubmit()}
            >
              <HideIcon style={{ transform: 'scale(0.75)' }} />
              <p>Hide</p>
            </HideButton>
          )}
          <DeleteButton
            aria-label="Class Card Delete Button"
            className="delete-button"
            dataTestId="delete-button"
            onClick={() => handleDeleteSubmit()}
          >
            <DeleteIcon />
            <p>Delete</p>
          </DeleteButton>
        </DropdownMenuWrapper>
      )}
    </Wrapper>
  )
}
DropdownMenu.propTypes = {
  className: PropTypes.string,
  courseInstanceName: PropTypes.string,
  dataTestId: PropTypes.string,
  forwardedRef: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.instanceOf(Element) }),
  ]),
  handleDeleteSubmit: PropTypes.func,
  handleEditSubmit: PropTypes.func,
  handleHideSubmit: PropTypes.func,
  isClassCardMenu: PropTypes.bool,
}

export default DropdownMenu
